import React, { useState, useEffect } from "react";
import leftArrowIcon from "../../../../../images/left-arrow-back.svg";
import saveimg from "../../../../../images/doc-input.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Select, Drawer, Button, Input, DatePicker } from "antd";
import { notify } from "../../../../../components/Snack";
import {
  updateFormatedData,
  convertToAutomation,
  getMetrics,
  setDateFilter,
} from "../../../../../redux/actions/skill";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const ProcessAction = (props) => {
  const skillInfo = useSelector((state) => state.skillReducer?.compareFlow);
  const selectedDate = useSelector((state) => state.skillReducer?.selectedDate);

  const [openExport, setOpenExport] = useState(false);
  const [flowData, setFlowData] = useState("");
  const [exportFlow, setIsExportFlow] = useState(false);
  const [automationName, setAutomationName] = useState("");
  const [automationDescription, setAutomationDescription] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const history = useHistory();
  const { Option } = Select;
  const dispatch = useDispatch();
  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let text = tempDiv.textContent || tempDiv.innerText || "";
    return tempDiv.textContent || tempDiv.innerText || "";
  };
  const backToggle = () => {
    history.goBack();
  };

  const sanitizedDescription = removeHtmlTags(props?.skillDescription);
  const openPanel = () => {
    setOpenExport(true);
  };

  const handleSubmit = async () => {
    setFlowData(flowData);
    setIsExportFlow(true);
    let rawData = flowData?.document;
    let TYPE = "SkillHub";
    let status = "pending";

    try {
      if (automationName == "" || automationDescription == "") {
        dispatch(
          notify("error", "Automation Name and Description is required")
        );
        setIsExportFlow(false);
        return;
      } else {
        let updatedData = {
          status,
          automationName,
          automationDescription,
          selectedTemplate,
          rawData,
          TYPE,
        };
        const updateSkill = await dispatch(convertToAutomation(updatedData));
        if (updateSkill?.msg) {
          setIsExportFlow(false);
          setOpenExport(false);

          dispatch(notify("error", `${updateSkill?.msg}`));
        } else if (updateSkill?.status) {
          setIsExportFlow(false);
          setOpenExport(false);
          dispatch(notify("success", "Converted to automation successfully"));
          history.push(
            `/dashboard/skills/viewSkill/${updateSkill?.data?.data?.id}`
          );
        }
      }
    } catch (err) {
      setIsExportFlow(false);
      setOpenExport(false);
    }
  };
  const handleCancel = () => {
    setOpenExport(false);
  };

  const onChange = (value) => {
    console.log(`selected ${value}`);
    let _d = skillInfo.filter((i) => i.id == value);
    setFlowData(_d[0]);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  const addSkillName = (value) => {
    setAutomationName(value);
  };

  const addSkillDescription = (value) => {
    setAutomationDescription(value);
  };

  const handleChange = (value) => {
    setSelectedTemplate(value);
  };

  const handleDateChange = (dates, dateString) => {
    let startDate =
      dateString[0] !== ""
        ? moment(dateString[0], "YYYY-MM-DD HH:mm:ss")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : null;
    let endDate =
      dateString[1] !== ""
        ? moment(dateString[1], "YYYY-MM-DD HH:mm:ss")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : null;
    dispatch(setDateFilter(dates));
    dispatch(getMetrics(props.id, startDate, endDate));
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <>
      <div className="flex-title rt-flex-title">
        <div className="cts-title">
          {/* SKILL initials */}
          <button
            className="btn btn-outline cts-btn-back"
            onClick={() => backToggle()}
          >
            <img src={leftArrowIcon} />
          </button>
          <div className="cts-ico">
            <span>
              {props?.skillName
                ? props?.skillName?.toUpperCase().charAt(0)
                : null}
            </span>
          </div>

          {/* Skill Name */}

          <div className="cts-title-subt">
            <div class="title-edit-skill">
              <div className="cts-title-text">
                <p>{props?.skillName}</p>
              </div>
              <div className="cts-desc-text">
                <div
                  className="cts-desc-text-hidden"
                  dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                ></div>
              </div>
            </div>
            {/* Template Name */}
            <span>Template : Process Discovery</span>
          </div>
        </div>
        {history.location?.pathname?.includes("/dashboard/skills/viewChart") ? (
          <div className="stats-block">
            <div className="stats-range">
              <FilterOutlined
                style={{
                  fontSize: "16px",
                  color: selectedDate ? "#1890ff" : undefined,
                }}
              />
              <RangePicker
                onChange={handleDateChange}
                defaultValue={selectedDate}
              />
            </div>
          </div>
        ) : (
          <div
            className="rt-btns"
            onClick={() => {
              openPanel();
            }}
          >
            <button class="sm-btn">
              <img src={saveimg} alt="" />
              <span>Convert To Automation</span>
            </button>
          </div>
        )}
      </div>
      <Drawer
        title="Convert To Automation"
        placement="right"
        width={300}
        visible={openExport}
        onClose={() => handleCancel()}
      >
        {openExport ? (
          <>
            {" "}
            <div className="convert-panel">
              <Select
                showSearch
                placeholder="Select variant to convert"
                optionFilterProp="children"
                onChange={onChange}
                onSearch={onSearch}
                filterOption={filterOption}
                style={{ width: 240 }}
                options={skillInfo?.map((item) => ({
                  label: item?.revision,
                  value: item?.id,
                }))}
              />

              <Input
                placeholder="Name Your Automation"
                required={true}
                onChange={(e) => {
                  addSkillName(e.target.value);
                }}
              />
              <Input
                placeholder="Describe Your Automation"
                required={true}
                onChange={(e) => {
                  addSkillDescription(e.target.value);
                }}
              />
              <Select
                placeholder="Select Template"
                style={{ width: 240 }}
                onChange={handleChange}
              >
                <Option value="Blank Template">Blank Template</Option>
                <Option value="In-App Walkthrough">In-App Walkthrough</Option>
              </Select>
            </div>
            <br></br>
            <div>
              <Button type="primary" onClick={handleSubmit}>
                {exportFlow ? (
                  <div class="sp sp-circle text-light"></div>
                ) : (
                  "Convert To Automation"
                )}
              </Button>
            </div>
          </>
        ) : null}
      </Drawer>{" "}
    </>
  );
};

export default ProcessAction;
